import { useQuery } from '@tanstack/react-query';
import { getAvgProcessingTime } from '../services/AnalyticReportsService';
export default function useAvgProcessingTime(filters) {
    return useQuery(['avgProcessingTime', filters.values.dateRange], () => getAvgProcessingTime(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
